
import {of as observableOf, throwError } from 'rxjs';

import {catchError, tap} from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthenticationService {


    public STRADM:string="admin";
    public STRAGN:string="agent";

    authorities=[];

    constructor ( private http: HttpClient) { }

    public getToken (): string {
        return localStorage.getItem( 'jwt_token' )  || '';
    }

    public static getToken2 (): string {
        return localStorage.getItem( 'jwt_token' )  || '';
    }

    public getRefreshToken (): string {
        return localStorage.getItem( 'refresh_token' )  || '';
    }

    public isAuthenticated ():boolean {
        var token= localStorage.getItem( 'jwt_token' );
        return token!=null;
    }


    public getAuthRole ():string | null {
        var type= localStorage.getItem('role_token');
        return type;
    }

    public getUserId ():string {
        var type= atob(localStorage.getItem('profile_id')  || '');
        return type;
    }

    public getUsername ():string {
        var name = atob(localStorage.getItem('user_name')  || '');
        return name;
    }

    public getFullName ():string | null {
        var name = localStorage.getItem('full_name');
        return name;
    }

    public getProfileInfo ():string {
        var profileItem = atob(localStorage.getItem('profile_info')  || '');
        return profileItem;
    }

    public getSupervisor ():string | null {
        var supervisor = localStorage.getItem('superVisor');
        return supervisor;
    }

    public getTenantId ():string {
        var id= JSON.parse(atob(localStorage.getItem('profile_info')  || '')).tenantId;
        return id;
    }
    public getloginUser ():string {
        var id= JSON.parse(atob(localStorage.getItem('profile_info')  || '')).login;
        return id;
    }

    public getAIFeature ():string | null {
        var aiFeature = atob(localStorage.getItem('aiFeatures')  || '');
        return aiFeature;
    }

    public getShowTour ():string | null {
        var tour = localStorage.getItem('showTour');
        return tour;
    }

    public isAdmin():boolean{

        return this.getAuthRole()==btoa(this.STRADM);
    }

    public isAgent():boolean{

        return this.getAuthRole()==btoa(this.STRAGN);
    }

    public getHomeAddress ():any{
         if(localStorage.getItem('home_address')){
        var address = JSON.parse(localStorage.getItem('home_address')  || '');
        return address;
         }
    }

    public getOfficeAddress ():any {
        console.log(localStorage.getItem('office_address') )
        if(localStorage.getItem('office_address')){
        var address = JSON.parse(localStorage.getItem('office_address')  || '');
        return address;
        }
    }

    public getUserBuffer ():string |null {
        var buffer = localStorage.getItem('buffer');
        return buffer;
    }

    public getUserTimezone ():string{
        var timezone = localStorage.getItem('timezone') || '';
        return timezone;
    }



    public addonFeature ():string |null {
        var addonFeature = localStorage.getItem('addonFeature');
        return addonFeature;
    }
    public menuType ():string |null {
        //var menuType = localStorage.getItem('menuType');
        var menuType = sessionStorage.getItem('menuType');
        return menuType;
    }
    public menuPermissions ():any |null {
        var menuPermissions = JSON.parse(localStorage.getItem('menuPermissions')  || '');
        return menuPermissions;
    }
    public shiftWorking ():string |null {
        var shiftWorking = localStorage.getItem('shiftWorking');
        return shiftWorking;
    }
    public allowAssignShift ():string | null{
        var allowAssignShift = localStorage.getItem('allowAssignShift');
        return allowAssignShift;
    }
        public addonFeatureList(): any[] {
            const raw = localStorage.getItem('addonFeatureList');
            // If raw is null, use '[]'
            return JSON.parse(raw || '[]');
        }
    public addonPackageList(): any[] {
            const raw = localStorage.getItem('addonPackageList');
            // If raw is null, use '[]'
            return JSON.parse(raw || '[]');
        }

     public addonPackageListToHide(): any[] {
            const raw = localStorage.getItem('addonPackageListToHide');
        try {
            return JSON.parse(raw || '[]');
        } catch (e) {
            // If parsing fails, reset to empty array and return []
            localStorage.setItem('addonPackageListToHide', '[]');
            return [];
        }
    }

    public can(module:string, action:string):boolean{
        var userType= atob(this.getAuthRole()  || '');

        var can=false;
        can=this._can(userType,module,action);


        return can;
    }

    private _can(userType:string, module:string,action:string){
        var can=false;
        var permissions : any[] = [JSON.parse(localStorage.getItem('permissions')  || '')];
        var roles = permissions.filter(per=>{
            return per.role==userType;
        }).map(res=>{
            return res.roles;
        });

        for(let r of roles){
            for(let r1 of r){
                if(r1.moduleName==module){
                    can=r1[action];
                }

            }
        }
        permissions = [];

        return can;
    }

    getAddonFeatureLists() {

          var addonFeatureLists = this.addonFeatureList();
          //console.log(addonFeatureLists,"===")
          var addonFeatureList =_.filter(addonFeatureLists, (o) => {return o == 'INVENTORY';});
          
          //SLA ========================================================
          var addonFeatureListSLA =_.filter(addonFeatureLists, (o) => { return o == 'SLA'; });
          //TTL ========================================================
          var addonFeatureListTTL =_.filter(addonFeatureLists, (o) => { return o == 'TTL_QC'; });//remove
           //Report2 ========================================================
            var addonFeatureReports2 =_.filter(addonFeatureLists, (o) => { return o == 'REPORT2'; });

          //TOUCHANDGO ========================================================
            var addonFeatureTOUCHANDGO =_.filter(addonFeatureLists, (o) => { return o == 'TOUCHANDGO'; });//remove
          //MAGNUM ========================================================
           var addonFeatureMAGNUM =_.filter(addonFeatureLists, (o) => { return o == 'MAGNUM'; });
           //HILLS ========================================================
           var addonFeatureHILLS =_.filter(addonFeatureLists, (o) => { return o == 'HILLS'; });
           //CHUBB ========================================================
           var addonFeatureCHUBB =_.filter(addonFeatureLists, (o) => { return o == 'CHUBB'; });
           //CHUBB ========================================================
           var addonFeatureSNL =_.filter(addonFeatureLists, (o) => { return o == 'SNL_TENANT'; });//remove
           //SWAP ASIA ========================================================
           var addonFeatureSWAPASIA =_.filter(addonFeatureLists, (o) => { return o == 'SWAP_ASIA'; });//remove
           //DYNAMIC MAINTENANCE ========================================================
           var addonFeatureDYNAMICMAINTENANCE =_.filter(addonFeatureLists, (o) => { return o == 'DYNAMIC_MAINTENANCE'; });
           //COFFEX ========================================================
           var addonFeatureCOFFEX =_.filter(addonFeatureLists, (o) => { return o == 'COFFEX'; });
           //PSS ========================================================
           var addonFeaturePSS =_.filter(addonFeatureLists, (o) => { return o == 'PSS'; });//remove
           //AGRIBIO ========================================================
           var addonFeatureAGRIBIO =_.filter(addonFeatureLists, (o) => { return o == 'AGRIBIO'; });
           //MACHINE_SPECIALIST ========================================================
           var addonFeatureMS =_.filter(addonFeatureLists, (o) => { return o == 'MACHINE_SPECIALIST'; });
            //CHECKLIST_JAVA ========================================================
            var addonFeatureChecklist =_.filter(addonFeatureLists, (o) => { return o == 'CHECKLIST_JAVA'; });//remove

            //STERRA ========================================================
            var addonFeatureSTERRA =_.filter(addonFeatureLists, (o) => { return o == 'STERRA'; });

            //SURVEY ========================================================
            var addonFeatureSURVEY =_.filter(addonFeatureLists, (o) => { return o == 'SURVEY'; });

             //PROJECT ========================================================
             var addonFeaturePROJECT =_.filter(addonFeatureLists, (o) => { return o == 'PROJECT'; });

              //DYNAMIC_FORM ========================================================
              var addonFeatureDF =_.filter(addonFeatureLists, (o) => { return o == 'DYNAMIC_FORM'; });

              //DYNAMIC_LABEL ========================================================
              var addonFeatureLABEL =_.filter(addonFeatureLists, (o) => { return o == 'LABEL'; });

              //WORKFLOW ========================================================
              var addonFeatureWORKFLOW =_.filter(addonFeatureLists, (o) => { return o == 'WORKFLOW'; });


               //PRICE_BOOK ========================================================
               var addonFeaturePRICEBOOK =_.filter(addonFeatureLists, (o) => { return o == 'PRICE_BOOK'; }); // Chubb Price Book 

              //AI ========================================================
              var addonFeatureAI =_.filter(addonFeatureLists, (o) => { return o == 'AI'; });
              //JO_TEMPLATE ========================================================
              var addonFeatureJOTEMPLATE =_.filter(addonFeatureLists, (o) => { return o == 'JO_TEMPLATE'; });

             //ONBOARD_DASHBOARD ========================================================
              var addonFeatureONBOARD =_.filter(addonFeatureLists, (o) => { return o == 'ONBOARD'; });
           
              //con_req ========================================================
              var addonFeatureCONREQ =_.filter(addonFeatureLists, (o) => { return o == 'CON_REQ'; });

              //PM3 (For new PM)========================================================
              var addonFeaturePM3 = _.filter(addonFeatureLists, (o) => { return o == 'PM3'; });
                //JO2 ========================================================
              var addonFeatureJO2 =_.filter(addonFeatureLists, (o) => { return o == 'JO2'; });
                //MANSOR ========================================================
              var addonFeatureMANSOR = _.filter(addonFeatureLists, (o) => { return o == 'MANSOR'; });
                //QR_SCAN_FORM ========================================================
               var addonFeatureQR_SCAN_FORM = _.filter(addonFeatureLists, (o) => { return o == 'QR_SCAN_FORM'; });
            var addonFeatureASSET_ANALYTICS = _.filter(addonFeatureLists, (o) => { return o == 'ASSET_ANALYTICS'; });

            //INTERCOM ========================================================
            var addonFeatureINTERCOM = _.filter(addonFeatureLists, (o) => { return o == 'INTERCOM'; });
            var addonFeatureOFFLINE = _.filter(addonFeatureLists, (o) => { return o == 'OFFLINE'; });

            
            //Temprarely added for testing purpose to show all add-on features in a single object, can be removed once we have a proper structure in place to handle add-on features in the application
             var addonFeatureENABLE_OLD_PM_VIEW = _.filter(addonFeatureLists, (o) => { return o == 'ENABLE_OLD_PM_VIEW'; });

            var addonFeatureQB = _.filter(addonFeatureLists, (o) => { return o == "QUICKBOOK"; });

               //addon for customer portal
            var addonFeatureCustomerPortal = _.filter( addonFeatureLists,(o) => { return o == "CUSTOMER_PORTAL"; });

            var addonFeaturePDF = _.filter(addonFeatureLists, (o) => { return o == "PDF_TEMPLATE"; });

            var addonFeatureXero = _.filter(addonFeatureLists, (o) => {
              return o == "XERO";
            });
            var addonFeatureSETUP2 = _.filter(addonFeatureLists, (o) => { return o == "SETUP2"; });
            var addonFeatureCERT_INS = _.filter(addonFeatureLists, (o) => { return o == "CERT_INS"; });
            var addonFeatureDASHBOARD_ASSETS = _.filter(addonFeatureLists, (o) => { return o == "DASHBOARD_ASSETS"; });
            var addonFeatureCLEANERAPP = _.filter(addonFeatureLists, (o) => { return o == "CLEANERAPP"; });
            var addonFeatureSITE_HIERARCHY = _.filter(addonFeatureLists, (o) => { return o == "SITE_HIERARCHY"; });

               //WORKFLOW2 ========================================================
              var addonFeatureWORKFLOW2 =_.filter(addonFeatureLists, (o) => { return o == 'WORKFLOW2'; });
              // LOOKUP_LOGIC: job-order lookup filters (S01–S30). Field values on the form are not gated by this.
              var addonFeatureLOOKUP_LOGIC =_.filter(addonFeatureLists, (o) => { return o == 'LOOKUP_LOGIC'; });
            //PERMISSION ========================================================
               var addonFeaturePERMISSION =_.filter(addonFeatureLists, (o) => { return o == 'PERMISSION'; });

               //TASK ========================================================
               var addonFeatureTASK =_.filter(addonFeatureLists, (o) => { return o == 'TASK'; });

                //MILESTONE ========================================================
               var addonFeatureMILESTONE =_.filter(addonFeatureLists, (o) => { return o == 'MILESTONE'; });

            var addonFeatureData = {
              addonINVENTORY: addonFeatureList[0] ? addonFeatureList[0] : null,
              addonSLA: addonFeatureListSLA[0] ? addonFeatureListSLA[0] : null,
              addonTTL: addonFeatureListTTL[0] ? addonFeatureListTTL[0] : null,
              addonReport2: addonFeatureReports2[0]
                ? addonFeatureReports2[0]
                : null,
              addonTOUCHANDGO: addonFeatureTOUCHANDGO[0]
                ? addonFeatureTOUCHANDGO[0]
                : null,
              addonMAGNUM: addonFeatureMAGNUM[0] ? addonFeatureMAGNUM[0] : null,
              addonHILLS: addonFeatureHILLS[0] ? addonFeatureHILLS[0] : null,
              addonCHUBB: addonFeatureCHUBB[0] ? addonFeatureCHUBB[0] : null,
              addonSNL: addonFeatureSNL[0] ? addonFeatureSNL[0] : null,
              addonSWAPASIA: addonFeatureSWAPASIA[0]
                ? addonFeatureSWAPASIA[0]
                : null,
              addonDYNAMICMAINTENANCE: addonFeatureDYNAMICMAINTENANCE[0]
                ? addonFeatureDYNAMICMAINTENANCE[0]
                : null,
              addonCOFFEX: addonFeatureCOFFEX[0] ? addonFeatureCOFFEX[0] : null,
              addonPSS: addonFeaturePSS[0] ? addonFeaturePSS[0] : null,
              addonAGRIBIO: addonFeatureAGRIBIO[0]
                ? addonFeatureAGRIBIO[0]
                : null,
              addonMS: addonFeatureMS[0] ? addonFeatureMS[0] : null,
              addonChecklist: addonFeatureChecklist[0]
                ? addonFeatureChecklist[0]
                : null,
              addonSTERRA: addonFeatureSTERRA[0] ? addonFeatureSTERRA[0] : null,
              addonSURVEY: addonFeatureSURVEY[0] ? addonFeatureSURVEY[0] : null,
              addonPROJECT: addonFeaturePROJECT[0]
                ? addonFeaturePROJECT[0]
                : null,
              addonDF: addonFeatureDF[0] ? addonFeatureDF[0] : null,
              addonLABEL: addonFeatureLABEL[0] ? addonFeatureLABEL[0] : null,
              addonWORKFLOW: addonFeatureWORKFLOW[0] ? addonFeatureWORKFLOW[0] : null,
              addonPRICEBOOK: addonFeaturePRICEBOOK[0] ? addonFeaturePRICEBOOK[0]  : null, // Chubb Price Book
              addonAI: addonFeatureAI[0] ? addonFeatureAI[0] : null,
              addonASSET_ANALYTICS: addonFeatureASSET_ANALYTICS[0] ? addonFeatureASSET_ANALYTICS[0] : null,
              addonJOTEMPLATE: addonFeatureJOTEMPLATE[0] ? addonFeatureJOTEMPLATE[0] : null,
              addonCONREQ: addonFeatureCONREQ[0] ? addonFeatureCONREQ[0] : null,
              addonONBOARD: addonFeatureONBOARD[0] ? addonFeatureONBOARD[0] : null,
              addonPM3: addonFeaturePM3[0] ? addonFeaturePM3[0] : null,
              addonJO2: addonFeatureJO2[0] ? addonFeatureJO2[0] : null,
              addonMANSOR: addonFeatureMANSOR[0] ? addonFeatureMANSOR[0] : null,
              addonQRSCANFORM: addonFeatureQR_SCAN_FORM[0] ? addonFeatureQR_SCAN_FORM[0] : null,
              addonINTERCOM: addonFeatureINTERCOM[0]? addonFeatureINTERCOM[0] : null,
              addonOFFLINE: addonFeatureOFFLINE[0] ? addonFeatureOFFLINE[0] : null,
              addonENABLEOLDPMVIEW: addonFeatureENABLE_OLD_PM_VIEW[0] ? addonFeatureENABLE_OLD_PM_VIEW[0]: null, // Temprarely added for testing purpose to show all add-on features in a single object, can be removed once we have a proper structure in place to handle add-on features in the application
              addonQB: addonFeatureQB[0] ? addonFeatureQB[0] : null,
              addonCustomerPortal: addonFeatureCustomerPortal[0] ? addonFeatureCustomerPortal[0] : null,
              addonPDF: addonFeaturePDF[0] ? addonFeaturePDF[0] : null,
              addonXero: addonFeatureXero[0] ? addonFeatureXero[0] : null,
              addonSETUP2: addonFeatureSETUP2[0] ? addonFeatureSETUP2[0] : null,
              addonCERT_INS: addonFeatureCERT_INS[0] ? addonFeatureCERT_INS[0] : null,
              addonDASHBOARDASSETS: addonFeatureDASHBOARD_ASSETS[0] ? addonFeatureDASHBOARD_ASSETS[0] : null,
              addonCLEANERAPP: addonFeatureCLEANERAPP[0] ? addonFeatureCLEANERAPP[0] : null,
              addonSITE_HIERARCHY: addonFeatureSITE_HIERARCHY[0] ? addonFeatureSITE_HIERARCHY[0] : null,
              addonWORKFLOW2: addonFeatureWORKFLOW2[0] ? addonFeatureWORKFLOW2[0] : null,
              addonLOOKUP_LOGIC: addonFeatureLOOKUP_LOGIC[0] ? addonFeatureLOOKUP_LOGIC[0] : null,
              addonPERMISSION: addonFeaturePERMISSION[0] ? addonFeaturePERMISSION[0] : null,
              addonTASK: addonFeatureTASK[0] ? addonFeatureTASK[0] : null,
              addonMILESTONE: addonFeatureMILESTONE[0] ? addonFeatureMILESTONE[0] : null,
            };
            console.log(addonFeatureData);
            return addonFeatureData;
        // this.storeLocation = new StoreLocation(this.holder);
        // //  this.storeLocation._setAirport('aa');
        // //console.log(this.storeLocation);
    
      }
    getAddonPackageLists(packageName:string,packageCode:any=null) {
            var addonPackageData = 'Old';
            var addonFeatureLists = this.addonPackageList();
            var addonPackage =_.filter(addonFeatureLists, (o) => {return o == packageName;});
            if(packageCode != 'Old'){
                addonPackageData = addonPackage[0] !== undefined ? addonPackage[0]: 'none';
                console.log(addonPackageData,"====");
                return addonPackageData;
            }else if(packageCode == 'Old'){
                return packageName;
            }else{
                return 'none';
            }
               
    
      }

      getPackageCodeWithList(packageName: any) {
        console.log("getPackageCodeWithList printing", packageName);
        var packageCode = localStorage.getItem("packageCode");
        return {
            packageCode: packageCode,
            addonPackageList: this.getAddonPackageLists(packageName,packageCode),
        };
      }

      getAddonPackageListsToHide(packageName:string) {
             var packageCode = localStorage.getItem("packageCode");
            var addonPackageData = false;
            var addonFeatureLists = this.addonPackageListToHide();
            var addonPackage =_.filter(addonFeatureLists, (o) => {return o == packageName;});
           
           // if(packageCode != 'Old'){
                addonPackageData = addonPackage[0] == undefined ?  true:false; // false = hide , true = show
                console.log(addonPackageData,"====**************",addonPackage[0]);
                return addonPackageData;
        //    }else{
        //         return true; // Dont hide if package code is old
        //     }
               
    
      }


      public setCompanyName(name : any) {
        localStorage.setItem("org_home", name);
      }
    
      public getCompanyName() {
        return localStorage.getItem("org_home");
      }

    public loginAgent (body:any) {

        let h = new Headers(
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            } );
        const options = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            })
             }

        //let body = `username=${ username }&password=${ password }`;
        return this.http.post( environment.base_url+"/agent/authenticate", body, options ).pipe(tap( (resp:any) => {
            ////console.log(resp);
            if ( resp ) {
            localStorage.setItem( 'jwt_token', resp.json().id_token );
            localStorage.setItem( 'role_token', btoa(this.STRAGN) );
            //localStorage.setItem( 'refresh_token', resp.json().refresh_token );
            }
        } ),catchError( error => {
            return observableOf( false );
        } ),);
    }


    //********************************************* For Admin Login ***********************************************/
    public loginAdmin (body:any) {

        let h = new HttpHeaders(
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        );
        const options =  { 
            headers: h} ;
        return this.http.post( environment.base_url+"/authenticate", body, options).pipe(tap( (resp: any) => {
            //console.log(resp.id_token)
            if ( resp ) {
            localStorage.setItem( 'jwt_token', resp.id_token );
            }
        } ),catchError( error => {
            return throwError( error );
        } ),);
    }

  

}
